<script>
  import { link } from "svelte-routing";
  import OffersSafetyMattersPriorBooking from "../components/OffersSafetyMattersPriorBooking.svelte";
</script>

<div class="image-background">
  <h1 class="header_text_wrapper text-left">
    <span>ACCOMODATION </span><span class="separator"></span>
  </h1>
</div>
<div class="d-flex accomodation-content flex-column">
  <div class="vc_row wpb_row vc_row-fluid accomodation_box">
    <div class="wpb_column vc_column_container vc_col-sm-12">
      <div class="vc_column-inner">
        <div class="wpb_wrapper">
          <div class="wpb_raw_code wpb_content_element wpb_raw_html">
            <div class="wpb_wrapper">
              <div class="calluna-room-carousel mist_accomodation">
                <div class="room-carousel" data-items="3">
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/luxury-heritage-cottage-heated-pool-hot-tub"
                      use:link
                      title="Premium Jacuzzi"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/oyal_Heritage_Luxury_Heated_pool_entry_best_resort_in_bangalore.jpeg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Luxury Heritage Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            Chettinad styled cottage with Heated Private Pool and Hot Tub
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 20,990* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/deluxe-hot-tub"
                      use:link
                      title="Premium Jacuzzi"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/Deluxe_Hot _Tub_home.jpeg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Deluxe Hot Tub</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            An Eco friendly bamboo cottage with Stone Hot tub
                            bath with pressure jets, ideal for couples.
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 13,990* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/premium-jacuzzi"
                      use:link
                      title="Premium Jacuzzi"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/premium-jacuzzi.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Premium Hot Tub</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            A Luxurious private in room hot tub <br />
                            ( Ideal for couple)
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 14,490* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/attached-pool"
                      use:link
                      title="Attached Pool"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/pool-page/pool.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Private Pool Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            A pool attached to the cottages <br />
                            ( Ideal for a group of two or four )
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 15,490* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/wooden-cottage"
                      use:link
                      title="Wooden Cottage"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/wooden-cottage.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Wooden Log Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            feel cozy in a cottage made of wood <br />
                            ( Ideal for couple )
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 10,990* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    class="room-item accomodation_boxes"
                    style="wdith: 448.667px !important;"
                  >
                    <a
                      href="/deluxe-cottage"
                      use:link
                      title="Deluxe Cottage"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/deluxe-cottage.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Deluxe Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>
                            Air Conditioned cottages with a south indian theme <br
                            />
                            ( Ideal for couple )
                          </p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>Starting at</span>
                            <span class="inline-price">₹ 10,490*</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/wooden-hut"
                      use:link
                      title="Wooden Hut"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/Wooden-hut-home.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Wooden Hut</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>Hut on Wheels (Ideal for couple)</p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>Starting at</span>
                            <span class="inline-price">₹ 10,490*</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div class="room-item accomodation_boxes">
                    <a
                      href="/premium-bamboo"
                      use:link
                      title="Premium Bamboo"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/bamboo1.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Premium Bamboo Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>A Luxurious Bamboo Cottage <br /></p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 10,990* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div class="room-item accomodation_boxes">
                    <a
                      href="/royal-cottage"
                      use:link
                      title="Royal Cottage"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/royal_cottage.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Royal Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>( Ideal for a group of 4 )</p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>Starting at</span>
                            <span class="inline-price">₹ 21,980* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div class="room-item accomodation_boxes">
                    <a
                      href="/tree-top"
                      use:link
                      title="Stilt Cottage"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/tree-top/tree_house.jpg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Stilt Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>( Ideal for couple)</p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 9,490*</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="room-item accomodation_boxes">
                    <a
                      href="/family-cottage"
                      use:link
                      title="Tree Top"
                      class="room-pic"
                      target="_top"
                    >
                      <img
                        src="/images/malnaduhome.jpeg"
                        alt=""
                        style="width: 100%;"
                      />
                      <div class="room-content-wrapper">
                        <span class="overlay"></span>
                        <div class="room-title">
                          <h3>Heritage Family Cottage</h3>
                        </div>
                        <div class="room-excerpt">
                          <p>( Ideal for a group of 8, with hot tub )</p>
                        </div>
                        <div class="room-price-wrapper">
                          <div class="room-price style-2">
                            <span>starting at</span>
                            <span class="inline-price">₹ 49,960* </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offers-safety-book">
    <OffersSafetyMattersPriorBooking />
  </div>
</div>

<style>
  .image-background {
    background: url("../images/Accomodation.jpg") no-repeat center;
  }
  .mist_accomodation .room-carousel .room-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    position: relative;
  }
  .mist_accomodation .room-carousel .room-item {
    height: 345px;
    width: 515px;
  }
  .mist_accomodation .room-item {
    height: 300px;
  }
  .accomodation_boxes {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
    border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4)
      rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
    border-image: none;
    border-radius: 25px;
    box-shadow: 8px 8px 8px #888888;
    width: 48% !important;
  }

  .accomodation_boxes .room-pic > img {
    border-radius: 25px;
    height: 330px;
    padding-left: 10px;
    padding-right: 10px;
    width: 560px;
  }
  .accomodation_boxes .room-pic > img {
    border-radius: 25px;
    padding-left: 10px;
    padding-right: 10px;
    width: 560px;
  }

  .room-carousel .room-content-wrapper {
    height: 100%;
    padding: 30px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .accomodation_boxes .room-content-wrapper .overlay {
    background-color: rgba(15, 36, 83, 0.4);
    border-radius: 15px;
    bottom: 7px;
    left: 10px;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 10px;
    top: 7px;
    transition: all 0.3s ease 0s;
  }

  .room-carousel .room-title {
    display: block;
    position: relative;
    text-align: center;
    top: 40%;
    transition: all 0.3s ease 0s;
  }

  .mist_accomodation .room-title {
    top: 10%;
  }

  .mist_accomodation .room-excerpt {
    top: -35px;
  }
  .room-carousel .room-excerpt {
    opacity: 0;
    position: relative;
    top: 22%;
    transition: opacity 0.3s ease 0s;
  }
  .room-carousel .room-excerpt {
    opacity: 0;
    position: relative;
    top: 22%;
    transition: opacity 0.3s ease 0s;
  }

  .mist_accomodation .room-carousel .room-excerpt {
    top: 10px;
  }

  .room-carousel .room-price-wrapper {
    bottom: 45px;
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
  }

  .room-carousel .room-content-wrapper:hover .room-price,
  .room-carousel .room-price.style-2 {
    background-color: #907650;
    border-color: #907650;
    color: #fff;
  }
  .room-carousel .room-price {
    border-radius: 3px;
    display: inline-block;
    font-family: Lato;
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: 0.1rem;
    padding: 14px 36px;
    text-transform: uppercase;
    transition: all 0.3s ease 0s;
  }

  .room-carousel .room-content-wrapper:hover .room-price,
  .room-carousel .room-price.style-2 {
    background-color: #907650;
    border-color: #907650;
    color: #fff;
  }
  .room-carousel .room-price {
    border-radius: 3px;
    display: inline-block;
    font-family: Lato;
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: 0.1rem;
    padding: 14px 36px;
    text-transform: uppercase;
    transition: all 0.3s ease 0s;
  }

  .room-carousel .room-title h3 {
    box-shadow: 0 0 2px 1px #fff;
    color: #fff;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .room-carousel .room-content-wrapper:hover .room-title {
    top: 0;
  }

  .room-carousel .room-content-wrapper:hover .overlay {
    background-color: rgba(150, 122, 80, 0.7);
  }

  .accomodation_boxes:nth-child(2n) {
    margin-bottom: 30px !important;
    margin-left: 30px !important;
  }

  .wpb_content_element {
    margin-bottom: 35px;
  }

  .accomodation_box {
    padding: 15px 8% 0 8%;
  }

  .accomodation-content {
    background: rgba(0, 0, 0, 0) url(../images/gpattern-opacity-1.png) repeat
      scroll 0 0;
  }

  .offers-safety-book {
    padding: 0 9%;
  }

  .room-carousel .room-content-wrapper:hover .room-excerpt {
    opacity: 1;
  }

  .room-carousel .room-excerpt p {
    color: #fff;
    text-align: justify;
  }

  @media only screen and (max-width: 768px) {
    .accomodation_boxes {
      margin-bottom: 30px !important;
      margin-left: 0 !important;
      width: 100% !important;
      padding: 15px 2% 0 0%;
    }

    .accomodation_boxes:nth-child(2n) {
      margin-left: 0 !important;
    }

    .accomodation_box {
      padding: 15px 4% 0 2%;
    }
  }

  @media only screen and (min-width: 320px) and (max-width: 600px) {
    .mist_accomodation .room-carousel .room-item {
      height: 250px;
    }

    .accomodation_boxes .room-pic > img {
      height: 100%;
    }
  }
</style>
